import React, { useEffect, useState, useContext } from "react";
import { getSalesReport, getServiceReport } from "../../../Utility/Api";
import { getFormattedCurrentDate2, NaviGate, shop_id } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import "./table.css";
import * as XLSX from "xlsx";

const Totaldailyreport = () => {
  const { showLoader, hideLoader } = useContext(WarehouseContext);

  const [activeFilter, setActiveFilter] = useState("Daily");
  const [customDates, setCustomDates] = useState({ from: "", to: "" });
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);


  // const handleClick = (filter) => {
  //   setActiveFilter(filter);
  //   // if (filter !== "custom") {
  //   //   onFilterChange && onFilterChange(filter);
  //   // }

  // };

  const handleCustomFilter = () => {
    if (customDates.from && customDates.to) {
      // onFilterChange && onFilterChange({ type: "custom", ...customDates });
    } else {
      alert("Please select both dates.");
    }
  };

  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState(getFormattedCurrentDate2());
  const [toDate, setToDate] = useState(getFormattedCurrentDate2());
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [invoiceDetail, setInvoiceDetail] = useState(null);


  useEffect(() => {
    fetchData();
  }, [fromDate, toDate]);

  const fetchData = async () => {
    try {
      showLoader();
      const filter = `from_date=${fromDate}&to_date=${toDate}&shop_id=${shop_id}`;
      const response = await getServiceReport(filter);
      if (response.data && response.data.data) {
        setData(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
      }
      hideLoader();
    } catch (error) {
      hideLoader();
      console.error("Error fetching order data:", error);
    }
  };

  const handleClick = (value) => {
    setActiveFilter(value);

    if (value === "invoice") {
      setShowInvoiceModal(true); // Show modal only for "invoice"
    } else {
      setShowInvoiceModal(false); // Close modal if switching to other filters
      // if (onFilterChange) {
      //   onFilterChange(value); // Call parent callback if provided
      // }
    }
  };


  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchData(pageNumber);
  };

  const handleSelectCustomer = (event) => {
    setSelectedCustomer(event.target.value);
  };

  const handlePaymentFilter = (event) => {
    setPaymentStatus(event.target.value);
  };

  const filteredData = data.filter((cus) =>
    (selectedCustomer ? cus.customer_name === selectedCustomer : true) &&
    (paymentStatus === "paid" ? cus.purchase_unit !== 2 : paymentStatus === "unpaid" ? cus.purchase_unit === 2 : true)
  );

  const exportToExcel = () => {
    const exportData = filteredData?.filter((data) => data.status != "-1").map((item) => ({
      Date: item.date,
      "Service No": item.service_no,
      "Customer Name": item.customer_name,
      Amount: item.total_amount,
      "Payment Status": item.purchase_unit == 2 ? "UnPaid" : "Paid"
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Service_Report");
    XLSX.writeFile(wb, `Service_Report_${fromDate}_to_${toDate}.xlsx`);
  };

  const handleShowInvoice = (item) => {
    const transformed = {
      invoice_id: item.invoice_number || item.id,
      customer_name: item.customer_name || "-",
      date: item.date || "-",
      service_no: item.service_no || "-",
      employee_name: item.employee_name || "-",
      title: item.title || "-",
      remark: item.remark || "-",
      total_amount: item.total_amount ?? 0,
      status: item.status === "1" ? "Paid" : "Unpaid",
      // Make sure item.items is available
      items: item.items?.map((i) => ({
        product_name: i.product_name || "N/A",
        serial_number: i.serial_number || "-",
        amount: i.amount ?? 0,
      })) || [],
    };

    console.log("Invoice Detail:", transformed); // Debug here
    setInvoiceDetail(transformed);
    setShowInvoiceModal(true);
  };




  return (
    <div className="page-wrappers">
      <div className="page-content py-1">
        <NaviGate />
        <form onSubmit={(e) => e.preventDefault()} className="card p-4 shadow-sm">
          <div className="row g-3 justify-content-end">
            <h5 className="mb-0 text-uppercase">Total Daily Report</h5>

            <div className="d-flex flex-wrap gap-3 mt-3 mb-4 justify-content-center">
              {[
                { label: "Daily", color: "primary", value: "Daily", icon: "bi-calendar-day" },
                { label: "Weekly", color: "success", value: "weekly", icon: "bi-calendar-week" },
                { label: "Monthly", color: "danger", value: "monthly", icon: "bi-calendar-month" },
                { label: "Custom", color: "dark", value: "custom", icon: "bi-sliders" },
              ].map((btn, index) => (
                <div className="col-md-2" key={index}>
                  <button
                    className={`btn w-100 d-flex align-items-center justify-content-center gap-2 fw-semibold shadow-sm ${activeFilter === btn.value ? `btn-${btn.color}` : `btn-outline-${btn.color}`
                      }`}
                    onClick={() => handleClick(btn.value)}
                    style={{ transition: "all 0.3s ease" }}
                  >
                    <i className={`bi ${btn.icon}`}></i> {btn.label}
                  </button>
                </div>
              ))}
            </div>


            {activeFilter === "custom" && (
              <div className="row align-items-end mb-3">
                <div className="col-md-3">
                  <label className="form-label">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={customDates.from}
                    onChange={(e) => setCustomDates({ ...customDates, from: e.target.value })}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={customDates.to}
                    onChange={(e) => setCustomDates({ ...customDates, to: e.target.value })}
                  />
                </div>
                <div className="col-md-2 mt-2 mt-md-4">
                  <button className="btn btn-outline-success w-100" onClick={handleCustomFilter}>
                    Filter
                  </button>
                </div>
              </div>
            )}

            {showInvoiceModal && invoiceDetail && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                style={{ background: "rgba(0, 0, 0, 0.5)" }}
                aria-modal="true"
                onClick={() => setShowInvoiceModal(false)} // click outside to close
              >
                <div
                  className="modal-dialog modal-lg modal-dialog-centered"
                  onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
                >
                  <div className="modal-content shadow border-0 rounded-4 overflow-hidden">
                    {/* Modal Header */}
                    <div className="modal-header bg-dark text-white">
                      <h5 className="modal-title">
                        <i className="bi bi-receipt me-2"></i>Invoice Details
                      </h5>
                      <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={() => setShowInvoiceModal(false)}
                        aria-label="Close"
                      ></button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body px-4">
                      <div className="row mb-3">
                        <div className="col-md-6"><strong>Invoice ID:</strong> {invoiceDetail.invoice_id}</div>
                        <div className="col-md-6"><strong>Service No:</strong> {invoiceDetail.service_no}</div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6"><strong>Customer:</strong> {invoiceDetail.customer_name}</div>
                        <div className="col-md-6"><strong>Employee:</strong> {invoiceDetail.employee_name}</div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6"><strong>Date:</strong> {invoiceDetail.date}</div>
                        <div className="col-md-6">
                          <strong>Status:</strong>{" "}
                          <span className={`fw-bold ms-2 ${invoiceDetail.status === 'Paid' ? 'text-success' : 'text-danger'}`}>
                            {invoiceDetail.status}
                          </span>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6"><strong>Title:</strong> {invoiceDetail.title}</div>
                        <div className="col-md-6"><strong>Remark:</strong> {invoiceDetail.remark}</div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6"><strong>Total Amount:</strong> ₹{invoiceDetail.total_amount}</div>
                      </div>

                      {/* Invoice Items Table */}
                      {invoiceDetail?.items?.length > 0 ? (
                        <table className="table table-bordered mt-3 text-center">
                          <thead className="bg-secondary text-white">
                            <tr>
                              <th>S.No</th>
                              <th>Product</th>
                              <th>Serial</th>
                              <th>Amount (INR)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoiceDetail.items.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.product_name}</td>
                                <td>{item.serial_number}</td>
                                <td>₹{item.amount}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <div className="text-muted text-center">No invoice items found.</div>
                      )}
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer border-0 px-4 pb-3">
                      <button className="btn btn-secondary px-4" onClick={() => setShowInvoiceModal(false)}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}





            {/* <div className="col-md-2">
              <button type="button" className="btn btn-success p-3 fw-semibold w-100" onClick={exportToExcel}>
                Export to Excel
              </button>
            </div> */}
          </div>

          <div className="table-responsive text-center my-2 w-100 position-relative">
            <table className="table table table-sm table-bordered">
              <thead className="table-dark">
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Service NO</th>
                  <th>Customer Name</th>
                  <th>Amount (INR)</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.date}</td>
                    <td>{item.service_no}</td>
                    <td>{item.customer_name}</td>
                    <td>{item.total_amount}</td>
                    <td>
                      <div className="d-flex justify-content-center align-items-center gap-3">
                        {/* <img
                          src="/assets/images/icons/view.png"
                          onClick={() => handleShowInvoice(item)}
                          height="20px"
                          style={{ cursor: "pointer" }}
                          alt="View"
                        /> */}
                        {item?.purchase_unit == 2 ? (
                          <span className="fw-bold text-danger">UnPaid</span>
                        ) : (
                          <span className="fw-bold text-success">Paid</span>
                        )}
                      </div>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>

            {/* <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} /> */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Totaldailyreport;